import React from 'react';
import Site from './Site';
import Order from './Order';
import TabCard from './TabCard';
import './index.scss';
interface Props {
  vehicleName: string;
  singleVehiclePageInfo: any;
  rightTab?: string;
}
const RightContainer = (props: Props) => {
  const { vehicleName, singleVehiclePageInfo, rightTab } = props;
  return (
    <>
      <div className="right-con">
        <Site vehicleName={vehicleName}></Site>
        <Order vehicleName={vehicleName}></Order>
        <TabCard
          vehicleName={vehicleName}
          singleVehiclePageInfo={singleVehiclePageInfo}
          rightTab={rightTab}
        ></TabCard>
      </div>
    </>
  );
};

export default React.memo(RightContainer);
